import React from 'react';
import { SteppedListSection, StepSectionState } from '../../../components/step-section';
import { ITimeBlockListing } from '../../../../../entities-generated/models/time-block/time-block-listing';
import { InstallationDateSelector } from '../../../components/install-date-selector';
import { BwjButton, BwjButtonType } from '../../../../../framework/components/bwj-button';

interface IPaymentSectionInstallDateProps {
  state: StepSectionState;
  onEditSection: () => void;
  onAdvanceToNextSection: () => void;
  selectedDate: ITimeBlockListing | null | undefined;
  installOptions: ITimeBlockListing[];
  onTimeSelected: (time: ITimeBlockListing) => void;
}

export const PaymentSectionInstallDate: React.FunctionComponent<IPaymentSectionInstallDateProps> = (props) => {

  return (
    <SteppedListSection
      id={'stnInstallation'}
      title={'Choose Your Install Date'}
      state={props.state}
      formBusy={false}
      onEditSection={props.onEditSection}
    >
      <p>
        <strong>We work on your schedule.</strong>&nbsp;
        Choose the date and time of day when you want us to deliver and install your order.  Our installers need entryway access from both the inside and outside of your home, so someone over the age of 18 must be present while we are there.
      </p>
      <InstallationDateSelector
        value={props.selectedDate}
        options={props.installOptions}
        onTimeSelected={props.onTimeSelected}
      />
      <BwjButton
        buttonStyle={BwjButtonType.PrimaryStandard}
        text={'Continue'}
        disabled={!props.selectedDate}
        onClick={props.onAdvanceToNextSection}
      />
    </SteppedListSection>
  );
};
